/**
 * Pure reset helper for the /options footer. It resets only settings owned
 * by shipped panes so placeholder tabs do not silently clobber fields they
 * have not exposed yet.
 */

import type { SaveGame } from "@/data/schemas";

export type OptionsResetResult =
  | { kind: "applied"; save: SaveGame }
  | { kind: "noop"; reason: "already-default" };

export function resetShippedOptionsToDefaults(
  save: SaveGame,
  defaults: SaveGame,
): OptionsResetResult {
  const next: SaveGame = {
    ...save,
    settings: {
      ...save.settings,
      assists: { ...defaults.settings.assists },
      audio: defaults.settings.audio,
      difficultyPreset: defaults.settings.difficultyPreset,
      displaySpeedUnit: defaults.settings.displaySpeedUnit,
      keyBindings: defaults.settings.keyBindings,
      graphics: defaults.settings.graphics,
    },
  };

  if (
    JSON.stringify(next.settings.assists) ===
      JSON.stringify(save.settings.assists) &&
    JSON.stringify(next.settings.audio) === JSON.stringify(save.settings.audio) &&
    next.settings.difficultyPreset === save.settings.difficultyPreset &&
    next.settings.displaySpeedUnit === save.settings.displaySpeedUnit &&
    JSON.stringify(next.settings.keyBindings) ===
      JSON.stringify(save.settings.keyBindings) &&
    JSON.stringify(next.settings.graphics) === JSON.stringify(save.settings.graphics)
  ) {
    return { kind: "noop", reason: "already-default" };
  }

  return { kind: "applied", save: next };
}
